import appCS from "./cs/app.json";
import signInCS from "./cs/sign-in.json";
import signUpCS from "./cs/sign-up.json";
import resetCS from "./cs/reset.json";
import socialCS from "./cs/social.json";

import appDA from "./da/app.json";
import signInDA from "./da/sign-in.json";
import signUpDA from "./da/sign-up.json";
import resetDA from "./da/reset.json";
import socialDA from "./da/social.json";

import appDE from "./de/app.json";
import signInDE from "./de/sign-in.json";
import signUpDE from "./de/sign-up.json";
import resetDE from "./de/reset.json";
import socialDE from "./de/social.json";

import appEL from "./el/app.json";
import signInEL from "./el/sign-in.json";
import signUpEL from "./el/sign-up.json";
import resetEL from "./el/reset.json";
import socialEL from "./el/social.json";

import appEN from "./en/app.json";
import signInEN from "./en/sign-in.json";
import signUpEN from "./en/sign-up.json";
import resetEN from "./en/reset.json";
import socialEN from "./en/social.json";

import signInENCA from "./en/sign-in.ca.json";

import appGbENIE from "./en/app.gb.json";
import signInGbENIE from "./en/sign-in.gb.json";
import signUpGbENIE from "./en/sign-up.gb.json";

import signUpENIN from "./en/sign-up.in.json";
import signInENIN from "./en/sign-in.in.json";

import signUpENAU from "./en/sign-up.au.json";

import appES from "./es/app.json";
import signInES from "./es/sign-in.json";
import signUpES from "./es/sign-up.json";
import resetES from "./es/reset.json";
import socialES from "./es/social.json";

import appESUS from "./es/app.us.json";
import signInESUS from "./es/sign-in.us.json";
import signUpESUS from "./es/sign-up.us.json";
import resetESUS from "./es/reset.us.json";
import socialESUS from "./es/social.us.json";

import appFI from "./fi/app.json";
import signInFI from "./fi/sign-in.json";
import signUpFI from "./fi/sign-up.json";
import resetFI from "./fi/reset.json";
import socialFI from "./fi/social.json";

import appFR from "./fr/app.json";
import signInFR from "./fr/sign-in.json";
import signUpFR from "./fr/sign-up.json";
import resetFR from "./fr/reset.json";
import socialFR from "./fr/social.json";

import appFRBE from "./fr/app.be.json";

import appFRCA from "./fr/app.ca.json";
import signInFRCA from "./fr/sign-in.ca.json";
import signUpFRCA from "./fr/sign-up.ca.json";
import resetFRCA from "./fr/reset.ca.json";
import socialFRCA from "./fr/social.ca.json";

import appHU from "./hu/app.json";
import signInHU from "./hu/sign-in.json";
import signUpHU from "./hu/sign-up.json";
import resetHU from "./hu/reset.json";
import socialHU from "./hu/social.json";

import appIT from "./it/app.json";
import signInIT from "./it/sign-in.json";
import signUpIT from "./it/sign-up.json";
import resetIT from "./it/reset.json";
import socialIT from "./it/social.json";

import appNB from "./nb/app.json";
import signInNB from "./nb/sign-in.json";
import signUpNB from "./nb/sign-up.json";
import resetNB from "./nb/reset.json";
import socialNB from "./nb/social.json";

import appNO from "./no/app.json";
import signInNO from "./no/sign-in.json";
import signUpNO from "./no/sign-up.json";
import resetNO from "./no/reset.json";
import socialNO from "./no/social.json";

import appJP from "./ja/app.json";
import signInJP from "./ja/sign-in.json";
import signUpJP from "./ja/sign-up.json";
import resetJP from "./ja/reset.json";
import socialJP from "./ja/social.json";

import appNL from "./nl/app.json";
import signInNL from "./nl/sign-in.json";
import signUpNL from "./nl/sign-up.json";
import resetNL from "./nl/reset.json";
import socialNL from "./nl/social.json";

import appNLBE from "./nl/app.be.json";

import appPT from "./pt/app.json";
import signInPT from "./pt/sign-in.json";
import signUpPT from "./pt/sign-up.json";
import resetPT from "./pt/reset.json";
import socialPT from "./pt/social.json";

import appPTBR from "./pt/app.br.json";
import signInPTBR from "./pt/sign-in.br.json";
import signUpPTBR from "./pt/sign-up.br.json";
import resetPTBR from "./pt/reset.br.json";
import socialPTBR from "./pt/social.br.json";

import appPL from "./pl/app.json";
import signInPL from "./pl/sign-in.json";
import signUpPL from "./pl/sign-up.json";
import resetPL from "./pl/reset.json";
import socialPL from "./pl/social.json";

import appRU from "./ru/app.json";
import signInRU from "./ru/sign-in.json";
import signUpRU from "./ru/sign-up.json";
import resetRU from "./ru/reset.json";
import socialRU from "./ru/social.json";

import appSV from "./sv/app.json";
import signInSV from "./sv/sign-in.json";
import signUpSV from "./sv/sign-up.json";
import resetSV from "./sv/reset.json";
import socialSV from "./sv/social.json";

import appTR from "./tr/app.json";
import signInTR from "./tr/sign-in.json";
import signUpTR from "./tr/sign-up.json";
import resetTR from "./tr/reset.json";
import socialTR from "./tr/social.json";

import appUK from "./uk/app.json";
import signInUK from "./uk/sign-in.json";
import signUpUK from "./uk/sign-up.json";
import resetUK from "./uk/reset.json";
import socialUK from "./uk/social.json";

export default {
  cs: {
    app: appCS,
    signIn: signInCS,
    signUp: signUpCS,
    reset: resetCS,
    social: socialCS
  },
  da: {
    app: appDA,
    signIn: signInDA,
    signUp: signUpDA,
    reset: resetDA,
    social: socialDA
  },
  ja: {
    app: appJP,
    signIn: signInJP,
    signUp: signUpJP,
    reset: resetJP,
    social: socialJP
  },
  de: {
    app: appDE,
    signIn: signInDE,
    signUp: signUpDE,
    reset: resetDE,
    social: socialDE
  },
  el: {
    app: appEL,
    signIn: signInEL,
    signUp: signUpEL,
    reset: resetEL,
    social: socialEL
  },
  en: {
    app: appEN,
    signIn: signInEN,
    signUp: signUpEN,
    reset: resetEN,
    social: socialEN
  },
  "en-IE": {
    app: appGbENIE,
    signIn: signInGbENIE,
    signUp: signUpGbENIE
  },
  "en-GB": {
    signIn: signInGbENIE,
    signUp: signUpGbENIE
  },
  "en-IN": {
    signIn: signInENIN,
    signUp: signUpENIN
  },
  "en-AU": {
    signUp: signUpENAU
  },
  "en-CA": {
    signIn: signInENCA
  },
  es: {
    app: appES,
    signIn: signInES,
    signUp: signUpES,
    reset: resetES,
    social: socialES
  },
  "es-US": {
    app: appESUS,
    signIn: signInESUS,
    signUp: signUpESUS,
    reset: resetESUS,
    social: socialESUS
  },
  fi: {
    app: appFI,
    signIn: signInFI,
    signUp: signUpFI,
    reset: resetFI,
    social: socialFI
  },
  fr: {
    app: appFR,
    signIn: signInFR,
    signUp: signUpFR,
    reset: resetFR,
    social: socialFR
  },
  "fr-BE": {
    app: appFRBE
  },
  "fr-CA": {
    app: appFRCA,
    signIn: signInFRCA,
    signUp: signUpFRCA,
    reset: resetFRCA,
    social: socialFRCA
  },
  hu: {
    app: appHU,
    signIn: signInHU,
    signUp: signUpHU,
    reset: resetHU,
    social: socialHU
  },
  it: {
    app: appIT,
    signIn: signInIT,
    signUp: signUpIT,
    reset: resetIT,
    social: socialIT
  },
  nb: {
    app: appNB,
    signIn: signInNB,
    signUp: signUpNB,
    reset: resetNB,
    social: socialNB
  },
  nl: {
    app: appNL,
    signIn: signInNL,
    signUp: signUpNL,
    reset: resetNL,
    social: socialNL
  },
  "nl-BE": {
    app: appNLBE
  },
  no: {
    app: appNO,
    signIn: signInNO,
    signUp: signUpNO,
    reset: resetNO,
    social: socialNO
  },
  pl: {
    app: appPL,
    signIn: signInPL,
    signUp: signUpPL,
    reset: resetPL,
    social: socialPL
  },
  pt: {
    app: appPT,
    signIn: signInPT,
    signUp: signUpPT,
    reset: resetPT,
    social: socialPT
  },
  "pt-BR": {
    app: appPTBR,
    signIn: signInPTBR,
    signUp: signUpPTBR,
    reset: resetPTBR,
    social: socialPTBR
  },
  ru: {
    app: appRU,
    signIn: signInRU,
    signUp: signUpRU,
    reset: resetRU,
    social: socialRU
  },
  sv: {
    app: appSV,
    signIn: signInSV,
    signUp: signUpSV,
    reset: resetSV,
    social: socialSV
  },
  tr: {
    app: appTR,
    signIn: signInTR,
    signUp: signUpTR,
    reset: resetTR,
    social: socialTR
  },
  uk: {
    app: appUK,
    signIn: signInUK,
    signUp: signUpUK,
    reset: resetUK,
    social: socialUK
  }
};
